import React from "react";
import { Trans, useTranslation } from "react-i18next";
import Layouts from "../../config/layouts/Layouts";
import NavbarComponent from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import emmpiezaCvImg from "../../assets/images/proyectos/cvagentic.png";
import "../../components/home/home.css";

const BENEFICIO_ICONS = {
    instant: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="pf-icon">
            <path fillRule="evenodd" d="M10 1a.75.75 0 01.75.75V4h-1.5V1.75A.75.75 0 0110 1ZM5.5 3.5A2.5 2.5 0 003 6v8a2.5 2.5 0 002.5 2.5h9A2.5 2.5 0 0017 14V6a2.5 2.5 0 00-2.5-2.5h-9Zm2 4.75a.75.75 0 000 1.5h5a.75.75 0 000-1.5h-5Zm0 3a.75.75 0 000 1.5h5a.75.75 0 000-1.5h-5Z" clipRule="evenodd" />
        </svg>
    ),
    actionable: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="pf-icon">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16Zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5Z" clipRule="evenodd" />
        </svg>
    ),
    detect: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="pf-icon">
            <path fillRule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6Zm0 8a1 1 0 100-2 1 1 0 000 2Z" clipRule="evenodd" />
        </svg>
    ),
    pricing: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="pf-icon">
            <path d="M10.75 10.818v2.614A3.13 3.13 0 0011.888 13c.482-.315.612-.648.612-.875 0-.227-.13-.56-.612-.875a3.13 3.13 0 00-1.138-.432ZM8.33 8.62c.053.055.115.11.184.164.208.16.46.284.736.363V6.603a2.45 2.45 0 00-.35.13c-.14.065-.27.143-.386.233-.377.292-.514.627-.514.909 0 .184.058.39.202.592.037.051.08.102.128.152Z" />
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16ZM10.75 4.75a.75.75 0 00-1.5 0v.7a4.25 4.25 0 00-1.334.51C7.14 6.427 6.5 7.263 6.5 8.269c0 .996.628 1.822 1.377 2.377.354.263.75.464 1.373.62v2.796a3.126 3.126 0 01-1.338-.432c-.421-.294-.703-.694-.703-1.13 0-.412.334-.746.75-.746a.75.75 0 000-1.5c-1.25 0-2.25 1.006-2.25 2.246 0 1.05.63 1.87 1.373 2.397a4.63 4.63 0 001.79.646v.703a.75.75 0 001.5 0v-.7c.463-.062.933-.203 1.339-.463C13.365 15.87 14 15.043 14 14.037c0-.997-.625-1.822-1.375-2.377-.353-.263-.749-.464-1.375-.622V8.242c.492.075.907.24 1.225.463.412.288.7.66.7 1.06a.75.75 0 001.5 0c0-.996-.626-1.822-1.376-2.376a4.234 4.234 0 00-1.549-.626v-.763.75Z" clipRule="evenodd" />
        </svg>
    ),
};

const BENEFICIO_KEYS = ["instant", "actionable", "detect", "pricing"];

function EmmpiezaCv() {
    const { t } = useTranslation();

    return (
        <Layouts>
            <header className="shrink-0">
                <NavbarComponent />
            </header>

            <main className="min-h-screen bg-em-bg pb-[calc(4rem+var(--em-footer-h))] text-em-text font-[Inter,system-ui,sans-serif]">
                <div className="mx-auto max-w-6xl px-5 md:px-8 pt-32 sm:pt-36 md:pt-40">
                    <p className="mb-3 inline-block rounded-full border border-em-accent2/30 bg-em-accent2/10 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-em-accent2">
                        {t("cv.eyebrow")}
                    </p>
                    <h1 className="max-w-4xl text-4xl font-black tracking-tight text-em-text md:text-5xl">
                        {t("cv.title")}
                    </h1>
                    <p className="mt-5 max-w-3xl text-lg leading-8 text-em-soft md:text-xl">
                        <Trans i18nKey="cv.lead" components={{ strong: <strong className="font-semibold text-em-text" /> }} />
                    </p>
                    <div className="mt-8">
                        <a
                            href="https://cvanalyzer.emmpieza.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-primary btn-lg"
                        >
                            {t("cv.ctaAnalyze")}
                        </a>
                    </div>
                </div>

                <section className="pf-section">
                    <div className="section-container">
                        <div className="pf-layout">
                            <div className="pf-left">
                                <h2 className="section-title">
                                    {t("cv.sectionTitle")}
                                </h2>
                                <p className="section-subtitle">
                                    {t("cv.sectionSubtitle")}
                                </p>

                                <div className="pf-grid" style={{ marginTop: "0.5rem" }}>
                                    {BENEFICIO_KEYS.map((key) => (
                                        <div className="pf-item" key={key}>
                                            <div className="pf-item-icon">{BENEFICIO_ICONS[key]}</div>
                                            <div>
                                                <p className="pf-item-title">{t(`cv.benefits.${key}.title`)}</p>
                                                <p className="pf-item-desc">{t(`cv.benefits.${key}.desc`)}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="pf-img-placeholder">
                                <img
                                    src={emmpiezaCvImg}
                                    alt={t("cv.imgAlt")}
                                    className="pf-img"
                                    loading="lazy"
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </Layouts>
    );
}

export default EmmpiezaCv;
